import { render, staticRenderFns } from "./ImportExportMenu.vue?vue&type=template&id=e7c342a4&"
import script from "./ImportExportMenu.vue?vue&type=script&lang=js&"
export * from "./ImportExportMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImportExportMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/ImportExportMenu.vue
// module id = 2238
// module chunks = 1